import React, { useEffect } from 'react'
import MUIDataTable from "mui-datatables";
import EditIcon from '@material-ui/icons/Edit';
import { createMuiTheme, MuiThemeProvider, Switch, TableCell, Tooltip, Typography, withStyles } from "@material-ui/core";
import AddPasien from './addPasien';
import AddDocter from './addDocter';
import DetailDocter from './detailDocter';
import FilterDocter from './filterDokter';
import { getDocter } from '../../store/actions/dokterAction';
import { useDispatch, useSelector } from 'react-redux';
import filterIcon from '../../assets/ic_search@3x.png';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import editIcon from '../../assets/ic_detail.png';
import Loader from 'react-loader-spinner'
import api from '../api';
import search from '../../assets/search.png';
import { useHistory } from 'react-router-dom';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const style = {
    position: "sticky",
    zIndex: 110
};

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});


export default function Screnning(props) {
    const history = useHistory()
    const [loading, setLoading] = React.useState(false)
    const [data, setData] = React.useState([])
    const [create, setCreate] = React.useState(false);
    const [read, setRead] = React.useState(false);
    const [update, setUpdate] = React.useState(false);
    const [deleted, setDeleted] = React.useState(false);

    const handleSeeDetail = ({ rowData }) => {
        history.push({
            pathname: "/masterdata/detail-skrining",
            name: 'Detail Skrining',
            state: {
                data: rowData
            }
        })
    }

    const handleStatus = () => {

    }

    React.useEffect(() => {
        props.setShowNotif(true)
        getData()
        getPermission(props)
        setLoading(true)
    }, [])

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    setDeleted(data.delete)
                }
            }
        })
    }

    const getData = () => {
        api.create().getScrenning().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let dataTable = response.data.data.map((item, index) => {
                        return [
                            index + 1,
                            item.form_title,
                            item.questions_count,
                            item.created_at,
                            item.created_by === null ? "" : item.created_by,
                            item.valid_date,
                            item.form_status,
                            "",
                            item.id
                        ]
                    })
                    setData(dataTable)
                    setLoading(false)
                }
            } else {
                setLoading(false)
            }
        })
    }

    const columns = [
        {
            name: "No",
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "form_title",
            label: "Judul Formulir",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "questions_count",
            label: "Total Pertanyaan",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "created_at",
            label: "Tanggal Pembuatan",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "created_by",
            label: "Dibuat Oleh",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "valid_date",
            label: "Tanggal Berlaku",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "status",
            label: "Status",
            options: {
                sort: true,
                sortThirdClickReset: true
            }
        },
        {
            name: "Detail",
            options: {
                filter: false,
                sort: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, backgroundColor: 'white', }}>
                        <Typography style={{ textAlign: 'center', fontWeight: 600 }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                // customHeadRender: (columnMeta) => (
                //     <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white' }}>
                //         <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                //     </TableCell>
                // ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            {read && (
                                <LightTooltip title={"Lihat"} arrow>
                                    <button
                                        onClick={() => handleSeeDetail(tableMeta)}
                                        style={{
                                            backgroundColor: "transparent",
                                            fontSize: 20,
                                            outline: 'none',
                                            borderColor: 'transparent',
                                            // marginRight: 10
                                        }}>
                                        <img src={editIcon} style={{ width: 30, height: 30 }} />
                                    </button>
                                </LightTooltip>
                            )}
                            {deleted && (
                                <LightTooltip title={`${tableMeta.rowData[6]}`} arrow>
                                    <button style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent'
                                    }}
                                        onClick={() => handleStatus(tableMeta)}>
                                        <IconSwitch
                                            checked={tableMeta.rowData[6] === 'Aktif' ? true : false}
                                        />
                                    </button>
                                </LightTooltip>
                            )}
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        }];

    const options = {
        filterType: 'multiselect',
        fixedHeader: true,
        filter: true,
        search: true,
        sort: true,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: 10,
        responsive: 'scrollMaxHeight',

    };


    const handleAdd = () => {
        history.push({
            pathname: '/masterdata/tambah-skrining',
            name: 'Tambah Skrining'
        })
    };

    const onClose = () => {
    };

    const handleChange = (value) => {
        console.log(value);
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            {loading ? loadingComponent : null}
            {create && (
                <div style={{ width: '40%', position: 'absolute', left: 10, top: 15, zIndex: '10' }}>
                    <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                        onClick={() => handleAdd()}
                    >
                        <div style={{ display: 'flex' }}>
                            <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                            <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 8, color: 'white' }}>Tambah</Typography>
                        </div>
                    </button>
                </div>
            )}
            {/* <div style={{ marginTop: 20, boxShadow: '5px 2px 10px 0 #999999', borderRadius: 30 }}> */}
            {read && (
                <div >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
            )}
        </div>
    )
}